// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f99898e8","239":"3ca7b520","732":"0eb3ae77"}[chunkId] + ".chunk.js";
};